<template>
    <div class="BookingAddress">
        <h2>{{ this.$store.getters.getCentro?.Descrizione }}</h2>
        <address>{{ this.$store.getters.getIndirizzoCompletoCentro  }}</address>
        <div class="Extra">Orari: {{ this.$store.getters.getCentro?.Orario }}</div>
        <div class="Extra">Telefono: <a :href="this.$store.getters.getCentro?.Telefono">{{ this.$store.getters.getCentro?.Telefono }}</a></div>
    </div>
</template>
<script>


export default{
    name: "BookingAddress"
    }    

</script>

